import axios from "axios";

export const updateSystemUserSettings = async (username, systemUserVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/systemUser/updateSettings", {username, systemUserVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const loadUserProfile = async (username) => {
    try {
        const {data} = await axios.post("/api/userProfile/loadUserProfile", {username});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateUserNotification = async (username, notificationVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/notification/update", {username, notificationVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}